// Исходы решения по операциям агента (одобрить / отклонить): статус строки или ошибка HTTP → тип и ключ текста.
// Общий словарь экрана «Ожидают одобрения» (AgentOperationsPending.vue) и карточки операции Ren в чате (AiActionCard.vue,
// FT-199): те же коды, те же тексты agent_operations.*. Модуль чистый — ни Vue, ни сети.

export const API_PATH = "/api/v1/agent_operations";

// Исход решения по статусу строки после попытки (200 одиночного решения, элемент пачки).
export const OUTCOME_BY_STATUS = {
  done: { type: "success", key: "agent_operations.outcome_done" },
  accepted: { type: "info", key: "agent_operations.outcome_accepted" },
  in_progress: { type: "info", key: "agent_operations.outcome_in_progress" },
  rejected: { type: "info", key: "agent_operations.outcome_rejected" },
  stale: { type: "warning", key: "agent_operations.outcome_stale" },
  expired: { type: "warning", key: "agent_operations.outcome_expired" },
};

// error_code строки `failed` → причина. Набор открыт (доменные коды) — неизвестный
// код даёт общую причину, машинный код пользователю не показывается.
export const FAILURE_KEYS = {
  forbidden: "agent_operations.failure_forbidden",
  money_scope_required: "agent_operations.failure_money_scope_required",
  tool_unavailable: "agent_operations.failure_tool_unavailable",
  interrupted: "agent_operations.failure_interrupted",
};
export const FAILURE_GENERIC = "agent_operations.failure_generic";

export const OUTCOME_ALREADY_DECIDED = { type: "warning", key: "agent_operations.outcome_already_decided" };
export const OUTCOME_NOT_FOUND = { type: "error", key: "agent_operations.outcome_not_found" };
export const OUTCOME_RETRY_LATER = { type: "warning", key: "agent_operations.outcome_retry_later" };
export const OUTCOME_FORBIDDEN = { type: "error", key: "agent_operations.outcome_forbidden" };
export const OUTCOME_DECISION_ERROR = { type: "error", key: "agent_operations.outcome_decision_error" };

export function outcomeForStatus(status, errorCode) {
  if (status === "failed") return { type: "error", key: FAILURE_KEYS[errorCode] || FAILURE_GENERIC };
  return OUTCOME_BY_STATUS[status] || null;
}

// 409 operation_not_pending: строку уже перевели — показываем, во что именно.
// in_progress / accepted приходят при гонке двух вкладок: соседняя ещё исполняет.
export function outcomeForNotPending(status) {
  if (status === "expired") return OUTCOME_BY_STATUS.expired;
  if (status === "in_progress") return OUTCOME_BY_STATUS.in_progress;
  if (status === "accepted") return OUTCOME_BY_STATUS.accepted;
  return OUTCOME_ALREADY_DECIDED;
}

// Элемент ответа пачки → исход. error: null — решение состоялось (в т. ч. stale/failed).
export function outcomeForBatchItem(entry) {
  const error = entry && entry.error;
  if (!error) return outcomeForStatus(entry.status, null) || OUTCOME_DECISION_ERROR;
  switch (error.code) {
    case "operation_not_pending": return outcomeForNotPending(entry.status);
    case "not_found": return OUTCOME_NOT_FOUND;
    case "locked": return OUTCOME_RETRY_LATER;
    case "forbidden": return OUTCOME_FORBIDDEN;
    default: return error.retryable ? OUTCOME_RETRY_LATER : OUTCOME_DECISION_ERROR;
  }
}

// Ошибка HTTP одиночного решения → { outcome, row } (row — строка из тела, если есть).
export function outcomeForDecisionError(err) {
  const response = err && err.response;
  const body = (response && response.data) || {};
  const error = body.error || {};
  const row = body.data && typeof body.data === "object" ? body.data : null;
  const httpStatus = response && response.status;
  if (httpStatus === 409 && error.code === "operation_not_pending") {
    return { outcome: outcomeForNotPending(error.status || (row && row.status)), row, status: error.status };
  }
  if (httpStatus === 404) return { outcome: OUTCOME_NOT_FOUND, row: null, status: null };
  if (httpStatus === 503 || error.retryable === true) return { outcome: OUTCOME_RETRY_LATER, row, status: null };
  if (httpStatus === 403) return { outcome: OUTCOME_FORBIDDEN, row, status: null };
  return { outcome: OUTCOME_DECISION_ERROR, row, status: null };
}
